import React from "react";

export const RouterContext = React.createContext({
	seenUrls: [],
	pageTitle: "lpg.space",
});